import { render } from "./AllReports.vue?vue&type=template&id=ad22f21a"
import script from "./AllReports.vue?vue&type=script&lang=js"
export * from "./AllReports.vue?vue&type=script&lang=js"

import "./AllReports.vue?vue&type=style&index=0&id=ad22f21a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__